import { render, staticRenderFns } from "./FeatureFlag.vue?vue&type=template&id=122bc5ec&"
import script from "./FeatureFlag.vue?vue&type=script&lang=js&"
export * from "./FeatureFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports